import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2 6v4h2V6h16v12h-9v2h9a1.93 1.93 0 0 0 1.413-.587A1.93 1.93 0 0 0 22 18V6c0-.55-.196-1.02-.587-1.412A1.926 1.926 0 0 0 20 4H4c-.55 0-1.02.196-1.412.588A1.924 1.924 0 0 0 2 6Z" }, null, -1),
    _createElementVNode("path", { d: "M7 20v-3h3v-2H7v-3H5v3H2v2h3v3h2Zm11-6.95h-8v-1.297L11.43 9.9l1.395 1.8 2.07-2.7L18 13.05Z" }, null, -1)
  ]))]))
}
export default { render: render }